// extracted by mini-css-extract-plugin
module.exports = {"features":"features-module--features--v3ElX","features__item":"features-module--features__item--YzkZB"};